import { CountryCodes } from "enums/LocationModalEnums";
import { string } from "yup";

const provinceValidation = string().when("countryCode", {
    is: (value: string) => value === CountryCodes.CANADA || value === CountryCodes.USA,
    then: string().required("Required"),
    otherwise: string().notRequired(),
});

export default provinceValidation
